module.exports = __webpack_public_path__ + "img/worldview.d07540fb.png";